import type { ReactElement } from "react";
import { useFeatureFlag } from "@jsq/flags-react";
import { EntitiesCardLegacy } from "./EntitiesCardLegacy";
import { EntitiesCardNew } from "./EntitiesCardNew";

type EntitiesCardProps = {
  clientId: string;
  clientName?: string;
  onChangeClientInfo?: () => void;
};

export const EntitiesCard = ({
  clientId,
  clientName,
  onChangeClientInfo,
}: EntitiesCardProps): ReactElement => {
  const isBillingFAManualTaggingEnabled = useFeatureFlag("billingFAManualTagging", false);

  if (isBillingFAManualTaggingEnabled) {
    return (
      <EntitiesCardNew
        clientId={clientId}
        clientName={clientName}
        onChangeClientInfo={onChangeClientInfo}
      />
    );
  }

  return <EntitiesCardLegacy clientId={clientId} />;
};
